import { render, staticRenderFns } from "./SocialButtons.vue?vue&type=template&id=2b4224a0&scoped=true&"
import script from "./SocialButtons.vue?vue&type=script&lang=js&"
export * from "./SocialButtons.vue?vue&type=script&lang=js&"
import style0 from "./SocialButtons.vue?vue&type=style&index=0&id=2b4224a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4224a0",
  null
  
)

export default component.exports